import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import headerUrls from 'configs/headerUrls';
import { useFooterStore } from 'stores/local/FooterStore';

import LegalItem from './LegalItem';

import s from './LegalList.module.scss';

type LegalListProps = {
  className?: string;
};

const LegalList: React.FC<LegalListProps> = ({ className }) => {
  const { legalItems } = useFooterStore();

  return (
    <ul className={cn(s.legalList, className)}>
      {legalItems.slice(0, 2).map((item) => (
        <li className={s.legalList__item} key={item.text}>
          <LegalItem url={item.url} text={item.text} />
        </li>
      ))}
      <li className={cn(s.legalList__item, s.legalList__item_wide)}>
        <LegalItem url={headerUrls.eduNavigation} text="Сведения об образовательной организации" />
      </li>
    </ul>
  );
};

export default observer(LegalList);
